import component from './PrivateColumnsConstructor.vue'
export default component
